import { Component, OnInit } from '@angular/core';
import { ButtonsPopupModel } from './buttons-popup.model';
import { ButtonsPopupService } from './service/buttons-popup.service';

@Component({
  selector: 'app-buttons-popup',
  templateUrl: './buttons-popup.component.html',
  styleUrls: ['./buttons-popup.component.scss']
})
export class ButtonsPopupComponent implements OnInit {
  public popObject: ButtonsPopupModel;

  constructor(private twoBtnService: ButtonsPopupService) { }

  ngOnInit() {
    this.twoBtnService.twoBtnSubject.subscribe(state => {
      this.popObject = state;
    });
  }

  clearState() {
    this.popObject = null;
  }
}
